/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

window._ = require('lodash')

window.Vue = require('vue').default;

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */


// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

// Vue.component('example-component', require('./components/ExampleComponent.vue').default);
Vue.component('pagination', require('laravel-vue-pagination'));
Vue.component('locations', require('./components/LocationsComponent.vue').default);
Vue.component('rotative-viewer', require('./components/RotativeViewerComponent.vue').default);
Vue.component('product-search', require('./components/ProductSearchComponent.vue').default);
Vue.component('wishlist-icon', require('./components/WishlistIconComponent.vue').default);
Vue.component('add-to-wishlist', require('./components/AddToWishlistComponent.vue').default);
Vue.component('product-specs', require('./components/ProductSpecsComponent.vue').default);
Vue.component('articles-list', require('./components/ArticlesComponent.vue').default);
Vue.component('case-studies', require('./components/CaseStudiesComponent.vue').default);
Vue.component('file-search', require('./components/FileSearchComponent.vue').default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const app = new Vue({
    el: '#app',
});


// window.onscroll = function() {
//     scrollProcess()
// };

// var header = document.getElementById("header-wrap");
// var sticky = header.offsetTop;

// function scrollProcess() {
//     if (window.pageYOffset > sticky) {
//         header.classList.add("sticky");
//     } else {
//         header.classList.remove("sticky");
//     }
// }
//
// uncomment to use in console
// <component ref="my_component"></component>
// eg: app.$refs.my_component.myFunction()
// window.app = app
